module.exports = __webpack_public_path__ + "static/media/checkmark.a838568b.svg";